import React, { useState } from 'react';
import { ICON_NEW } from '../extras/icons';
import MainContent from '../layout/MainContent';
import LevelList from './levels/LevelList';
import LevelForm from './levels/LevelForm';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { addLevelsAction } from '../../actions/levelsActions';
import AuthoritiesService from '../../services/AuthoritiesService';
import { NIVELES_MODIFICAR } from '../../data/objects';
//Función principal
const Levels = () => {
    //Inicializo el state local
    const [show, setShow] = useState(false);
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Manejo el insert
    const handleCreate = () => {
        //Llamo al dispatch
        dispatch( addLevelsAction(handleOpen) );
    }
    //Nodos
    const nodes = [];
    //Actions
    const actions = [{
        title: 'NUEVO',
        css: 'success',
        icon: <ICON_NEW className="fa-sm text-white-50" />,
        handle: handleCreate,
        granted: authorities && AuthoritiesService.hasPermission(authorities, NIVELES_MODIFICAR)
    }];
    //Manejo la apertura de la ventana
    const handleOpen = () => {
        setShow(true);
    }
    //Manejo el cierre de la ventana
    const handleClose = () => {
        setShow(false);
    }
    //Renderizo
    return (
        <React.Fragment>
            <MainContent 
                title='Niveles' 
                subtitle='Administración' 
                nodes={nodes}
                actions={actions}
                component={LevelList}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />

            <LevelForm
                show={show}
                handleClose={handleClose}
            />
        </React.Fragment>
    );
};

export default Levels;